export const optionsLitigationStatus: string[] = [
    "",
    "Discovery",
    "Dismissal",
    "Mediation",
    "Pleadings",
];
